<template>
  <q-layout>
    <q-page-container>
      <div class="row q-pa-md">
        <div class="row col-12 bg-white q-mt-md chart-box q-pa-md filter-box">
          <div class="text-primary q-mb-sm text-h6">Filter</div>
          <q-select
            outlined
            dense
            v-model="input.displayMode"
            :options="['By Day', 'By Week', 'By Month']"
            class="col-12"
          ></q-select>

          <date-picker
            v-if="input.displayMode === 'By Day'"
            v-model="input.filter"
            value-type="date"
            placeholder="Select date"
            class="col-12 q-pt-md"
          ></date-picker>
          <date-picker
            :lang="lang"
            v-if="input.displayMode === 'By Week'"
            v-model="input.filter"
            type="week"
            placeholder="Select week"
            class="col-12 q-pt-md"
          ></date-picker>
          <date-picker
            v-if="input.displayMode === 'By Month'"
            v-model="input.filter"
            type="month"
            placeholder="Select month"
            class="col-12 q-pt-md"
          ></date-picker>
          <div class="col-12 row justify-end q-gutter-x-sm">
            <q-btn
              :disable="!exportable"
              class="q-mt-md"
              label="Export"
              no-caps
              no-wrap
              color="accent"
              @click="onExport"
            ></q-btn>
            <q-btn
              v-if="input.displayMode === 'By Day'"
              :loading="refreshLoading"
              class="q-mt-md"
              label="Refresh"
              outline
              no-caps
              no-wrap
              color="primary"
              @click="onRefreshDialog"
            ></q-btn>
            <q-btn
              :disable="refreshLoading"
              class="q-mt-md"
              label="Apply"
              no-caps
              no-wrap
              color="primary"
              @click="onApply"
            ></q-btn>
          </div>
        </div>

        <div class="chart-content row col-12" v-if="rawData">
          <div class="col-12 bg-white q-mt-md chart-box q-pa-md">
            <div class="row full-width justify-between">
              <div class="text-primary text-h6">Sales</div>
              <q-toggle
                v-model="isSort.sale"
                label="Sort by value"
                left-label
              />
            </div>
            <horizontal-bar-chart
              ref="sale_chart"
              id="sale-chart"
              :chart-data="saleDatacollection"
              :options="saleOptions"
              :styles="chartStyle"
            ></horizontal-bar-chart>
          </div>

          <div class="col-12 bg-white q-mt-md chart-box q-pa-md">
            <div class="row full-width justify-between">
              <div class="text-primary text-h6">Order</div>
              <q-toggle
                v-model="isSort.order"
                label="Sort by value"
                left-label
              />
            </div>
            <horizontal-bar-chart
              id="order-chart"
              :chart-data="orderDatacollection"
              :options="orderOptions"
              :styles="chartStyle"
            ></horizontal-bar-chart>
          </div>

          <div class="col-12 bg-white q-mt-md chart-box q-pa-md">
            <div class="row full-width justify-between">
              <div class="text-primary text-h6">Customer</div>
              <q-toggle
                v-model="isSort.customer"
                label="Sort by value"
                left-label
              />
            </div>
            <horizontal-bar-chart
              id="customer-chart"
              :chart-data="customerDatacollection"
              :options="customerOptions"
              :styles="chartStyle"
            ></horizontal-bar-chart>
          </div>
        </div>
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { QCard, QCardSection, QCardActions, QSelect } from "quasar";
// import BarChart from "./BarChart.js";
import HorizontalBarChart from "./HorizontalBarChart.js";
import dayjs from "dayjs";
import { mapState } from "vuex";

const components = { QCard, QCardSection, QCardActions, QSelect };

export default {
  name: "AllSaleStat",
  components: {
    ...components,
    // LineChart,
    // BarChart,
    HorizontalBarChart,
    DatePicker,
  },
  data() {
    return {
      lang: {
        formatLocale: {
          firstWeekContainsDate: 4,
        },
      },
      refreshLoading: false,
      isSort: {
        sale: true,
        order: true,
        customer: true,
      },
      rawData: undefined,
      saleOptions: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return data["labels"][tooltipItem[0]["index"]];
            },
            label: function (tooltipItem, data) {
              return new Intl.NumberFormat().format(
                data["datasets"][0]["data"][tooltipItem["index"]]
              );
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Day",
            },
          },
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Sale name",
              },
              ticks: {
                beginAtZero: true,
                min: 0,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Revenue (฿)",
              },
              ticks: {
                beginAtZero: true,
                callback: (value, index, values) => {
                  return new Intl.NumberFormat().format(value);
                },
              },
            },
          ],
        },
      },
      orderOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: "Day",
            },
          },
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Sale name",
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Number of order",
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
                callback: (value, index, values) => {
                  return new Intl.NumberFormat().format(value);
                },
              },
            },
          ],
        },
      },
      customerOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: "Day",
            },
          },
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Sale name",
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Number of customer",
              },
              ticks: {
                beginAtZero: true,
                precision: 0,
                callback: (value, index, values) => {
                  return new Intl.NumberFormat().format(value);
                },
              },
            },
          ],
        },
      },
      input: {
        displayMode: "By Day",
        filter: null,
      },
      height: 150,
    };
  },
  computed: {
    ...mapState("admin", ["loading", "user", "groups"]),
    chartStyle() {
      return {
        height: `${this.height + this.rawData.length * 20}px`,
        position: "relative",
      };
    },
    isShow() {
      return this.rawData.length > 0 ? true : false;
    },
    saleDatacollection() {
      let labels = [];
      let data = [];

      //   labels = branchList.map((b) => b.name);
      //   data = branchList.map((b) => {
      //     const data = this.rawData.find((r) => r.id === b.code);
      //     if (["", null, undefined].indexOf(data) >= 0) {
      //       return 0;
      //     }
      //     return data.totalSaleVolume;
      //   });

      this.rawData.forEach((d) => {
        if (d.sale) {
          if (d.sale.firstname || d.sale.lastname) {
            const label = `${d.sale.firstname} ${d.sale.lastname} (${d.sale.branch})`;
            labels.push(label.trim());
          } else {
            labels.push(d.sale.username);
          }
        } else {
          labels.push(d.sale.username);
        }
        data.push(d.totalSaleVolume);
      });

      //sort
      if (this.isSort.sale) {
        const toSorted = labels.map((l, index) => {
          return {
            name: labels[index],
            value: data[index],
          };
        });

        toSorted.sort((a, b) => {
          if (a.value > b.value) return -1;
          if (a.value < b.value) return 1;
          return 0;
        });

        labels = toSorted.map((s) => s.name);
        data = toSorted.map((s) => s.value);
      }
      //end sort

      return {
        labels: labels,
        color: [],
        datasets: [
          {
            label: "Sales",
            data: data,
            backgroundColor: "#2c2a74",
          },
        ],
      };
    },
    orderDatacollection() {
      let labels = [];
      let data = [];

      this.rawData.forEach((d) => {
        if (d.sale) {
          if (d.sale.firstname || d.sale.lastname) {
            const label = `${d.sale.firstname} ${d.sale.lastname} (${d.sale.branch})`;
            labels.push(label.trim());
          } else {
            labels.push(d.sale.username);
          }
        } else {
          labels.push(d.sale.username);
        }
        data.push(d.totalOrder);
      });

      //sort
      if (this.isSort.order) {
        const toSorted = labels.map((l, index) => {
          return {
            name: labels[index],
            value: data[index],
          };
        });

        toSorted.sort((a, b) => {
          if (a.value > b.value) return -1;
          if (a.value < b.value) return 1;
          return 0;
        });

        labels = toSorted.map((s) => s.name);
        data = toSorted.map((s) => s.value);
      }
      //end sort

      return {
        labels: labels,
        color: [],
        datasets: [
          {
            label: "Order",
            data: data,
            backgroundColor: "#2c2a74",
          },
        ],
      };
    },
    customerDatacollection() {
      let labels = [];
      let data = [];

      this.rawData.forEach((d) => {
        if (d.sale) {
          if (d.sale.firstname || d.sale.lastname) {
            const label = `${d.sale.firstname} ${d.sale.lastname} (${d.sale.branch})`;
            labels.push(label.trim());
          } else {
            labels.push(d.sale.username);
          }
        } else {
          labels.push(d.sale.username);
        }
        data.push(d.totalCustomer);
      });

      //sort
      if (this.isSort.customer) {
        const toSorted = labels.map((l, index) => {
          return {
            name: labels[index],
            value: data[index],
          };
        });

        toSorted.sort((a, b) => {
          if (a.value > b.value) return -1;
          if (a.value < b.value) return 1;
          return 0;
        });

        labels = toSorted.map((s) => s.name);
        data = toSorted.map((s) => s.value);
      }
      //end sort

      return {
        labels: labels,
        color: [],
        datasets: [
          {
            label: "Customer",
            data: data,
            backgroundColor: "#2c2a74",
          },
        ],
      };
    },
    exportable() {
      if (this.rawData && this.rawData?.length > 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    "input.displayMode": {
      immediate: false,
      handler: function (displayMode) {
        switch (displayMode) {
          case "By Day":
            {
              // load current date
              const now = dayjs();
              this.input.filter = now.startOf("day").toDate();
            }
            break;
          case "By Week":
            {
              // load current week
              const now = dayjs();
              this.input.filter = now.startOf("week").toDate();
            }
            break;
          case "By Month":
            {
              // load current month
              const now = dayjs();
              this.input.filter = now.startOf("month").toDate();
            }
            break;
          default:
            break;
        }
      },
    },
  },
  created() {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    this.input.filter = date;
    // console.log("created", date);
  },
  methods: {
    onRefreshDialog() {
      this.$q
        .dialog({
          title: "Refresh",
          message:
            "Refresh database may take a few minutes.\nHowever the database is refreshed automatically everynight(00:00).",
          persistent: true,
          cancel: true,
          ok: "Continue",
        })
        .onOk(() => {
          this.onRefresh();
        });
    },
    async onRefresh() {
      console.log("onRefresh");
      try {
        this.refreshLoading = true;
        // TODO call dailyReportGenerator api
        await this.$services.allSaleStat.refrehsDailyStat();
        this.refreshLoading = false;
      } catch (error) {
        this.refreshLoading = false;
      }

      // TODO call onApply
      this.onApply();
    },
    onApply() {
      switch (this.input.displayMode) {
        case "By Day":
          this.getDaily();
          break;
        case "By Week":
          this.getWeekly();
          break;
        case "By Month":
          this.getMonthly();
          break;
        default:
          this.getDaily();
          break;
      }
    },
    async getDaily() {
      const result = await this.$services.allSaleStat.listDailyStat(
        this.input.filter
      );
      console.log("getDaily", result);
      this.rawData = result;
    },
    async getWeekly() {
      const result = await this.$services.allSaleStat.listWeeklyStat(
        this.input.filter
      );
      console.log(result);
      this.rawData = result;
    },
    async getMonthly() {
      const result = await this.$services.allSaleStat.listMonthlyStat(
        this.input.filter
      );
      console.log(result);
      this.rawData = result;
    },
    onExport() {
      if (!(this.rawData && this.rawData?.length > 0)) {
        console.log("No data!");
        return;
      }
      try {
        // Convert to csv
        // - Create header
        const headers = {
          id: "Sale ID",
          name: "Name",
          sales: "Sales",
          order: "Order",
          customer: "Customer",
        };

        let fileTitle;
        let mode;
        let dtStart; //date time
        let dtEnd;

        switch (this.input.displayMode) {
          case "By Day":
            mode = "Daily";
            dtStart = dayjs(this.input.filter).format("YYYY/MM/DD");
            fileTitle = `${mode}-report-${dtStart}`;
            break;
          case "By Week":
            mode = "Weekly";
            dtStart = dayjs(this.input.filter)
              .startOf("week")
              .format("YYYY/MM/DD");
            dtEnd = dayjs(this.input.filter).endOf("week").format("YYYY/MM/DD");
            fileTitle = `${mode}-report-${dtStart}-${dtEnd}`;
            break;
          case "By Month":
            mode = "Monthly";
            dtStart = dayjs(this.input.filter).format("MMMM-YYYY");
            fileTitle = `${mode}-report-${dtStart}`;
            break;
          default:
            mode = null;
            break;
        }

        console.log("dt:", dtStart, dtEnd, fileTitle);

        let itemsFormatted = [];

        this.rawData.forEach((data) => {
          let name;
          if (data.sale.firstname) {
            name = `${data.sale.firstname} `;
            if (data.sale.lastname) {
              name = name.concat(data.sale.lastname);
            }
          } else {
            name = data.sale.username;
          }

          itemsFormatted.push({
            id: data.sale.id,
            name: name,
            sales: data.totalSaleVolume,
            order: data.totalOrder,
            customer: data.totalCustomer,
          });
        });

        this.exportCSVFile(headers, itemsFormatted, fileTitle);
      } catch (error) {
        console.log(error);
      }
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);
      var csv = this.convertToCSV(jsonObject);
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8;",
      });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        // console.log("link", link.download)
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
  },
};
</script>

<style scoped>

.chart-box {
  border-radius: 10px;
}
>>> .mx-input {
  height: 40px !important;
}
>>> .chartjs-render-monitor {
  height: 600px;
}

</style>
